module.exports = __webpack_public_path__ + "img/gamecards.b0dc198.svg";